<div class="w-[900px] max-h-[600px] overflow-y-auto">
  <!-- Header -->
  <div class="flex items-center justify-between mb-4">
    <span class="text-[15px] font-bold text-[var(--base-text-dark)]">Add Fields to batch update</span>
    <span class="material-icons cursor-pointer text-[var(--tertiary-text)] text-[20px] rounded-full w-7 h-7 flex items-center justify-center hover:bg-[var(--app-base)]"
      (click)="close()">close</span>
  </div>

  <!-- Actions -->
  <div class="flex items-center gap-3 mb-4">
    <button (click)="addFields()"
      class="py-2 px-4 border-none rounded-lg text-xs font-semibold bg-[var(--primary-dark)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
      <span class="material-icons text-[16px]">add</span> Add Fields
    </button>

    <mat-form-field class="w-[200px]" appearance="outline">
      <mat-label appRemoveAriaOwns>Field Type</mat-label>
      <mat-select (selectionChange)="populateSelectableFarmAndFieldDetails()" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedType">
        <mat-option *ngFor="let type of filterTypes" [value]="type">
          {{type ? type.description : placeholder}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Farm/Field List -->
  <div class="max-h-[400px] overflow-y-auto">
    <mat-accordion *ngFor="let farm of filteredFarms; let farmIndex = index">
      <mat-expansion-panel class="!mb-2 !rounded-lg !shadow-[0_1px_4px_rgba(0,0,0,0.06)]">
        <mat-expansion-panel-header>
          <mat-panel-title class="!text-[14px] !font-medium !flex !items-center !gap-2">
            <mat-checkbox
              [indeterminate]="farm.isTouched && !farm.isSelected"
              (change)="toggleAllFarmFieldsSelection($event, farmIndex)"
              (click)="$event.stopPropagation()"
              [checked]="farm.isSelected">
            </mat-checkbox>
            {{farm.name}}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngFor="let field of farm.fields; let fieldIndex = index"
          class="flex items-center gap-2 py-1.5 px-2 text-[12px] flex-wrap">
          <mat-checkbox
            (change)="onFieldSelectedChecked($event, farmIndex, fieldIndex)"
            [(ngModel)]="field.isChecked">
          </mat-checkbox>
          <span class="font-semibold">Field Name:</span>
          <span class="w-[100px] truncate">{{field.fieldName ?? placeholder}}</span>
          <span class="font-semibold">Size HA:</span>
          <span class="w-[60px]">{{field.fieldSize ? (field.fieldSize | truncDecimals:3) : placeholder}}</span>
          <span class="font-semibold">In Active Season:</span>
          <span>{{field.isInAnotherActiveSeason ? "YES" : "NO"}}</span>
          <span class="font-semibold">Field Type:</span>
          <span>{{field?.description ?? "N/A"}}</span>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
